import { useState } from "react";
import uplodIcon from "../../../assets/images/upload-icon.png";
import DocImg from "../../../assets/images/doc-image.png";
import { toast, ToastContainer } from "react-toastify";
import { CreateMediaHubApi } from "../../../services/apis/EventMangement/CreateEventApi";
import BtnLoader from "../Loader/BtnLoader";
import Swal from "sweetalert2";

const MediaHub = ({ eventId, setTabValue }) => {
    const [logo, setLogo] = useState(null);
    // video link
    const [video_link, setVideo_link] = useState('');
    const [multipleVideoLink, setMultipleVideoLink] = useState([]);
    //video state
    const [bannerMultiple, setBannerMultiple] = useState([]);
    // multile images
    const [images, setImages] = useState([]);
    // multiple Document
    const [documents, setDocuments] = useState([]);
    const [btnLoader,setBtnLoader]=useState(false);
    const [errors, setErrors] = useState({});
    // ---------------------------------------

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        setLogo(file)
    };

    const handleDeleteLogo = () => {
        setLogo(null);
        document.getElementById("logoUpload").value = "";
    };

    // ---------------------------------------

    const handleMultipleBanner = (event) => {
        const selectedFiles = Array.from(event.target.files);
        const totalImages = images.length + selectedFiles.length;

        if (totalImages > 6) {
            alert('You can only upload up to 6 images.');
            return;
        }

        // Update state with new images
        setBannerMultiple((prevImages) => [...prevImages, ...selectedFiles]);
    };

    const handleMultipleDltBanner = (index) => {
        setBannerMultiple((prevImages) => prevImages.filter((_, i) => i !== index));
    }

    //----------------------------------------


    const handleAddMultipleURL = () => {
        if (video_link.trim() !== '') {
            const updatedLinks = [...multipleVideoLink, video_link];
            if (updatedLinks.length <= 5) {
                setMultipleVideoLink(updatedLinks);
                setVideo_link('');
            } else {
                toast.warn("You can only add up to 5 video links.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    theme: "light",
                });
            }
        }
    };

    const handleDeleteURL = (index) => {
        const updatedVideoLinks = multipleVideoLink.filter((item, idx) => idx !== index);
        setMultipleVideoLink(updatedVideoLinks);
    };

    //----------------------------------------

    const handleImageChange = (event) => {
        const selectedFiles = Array.from(event.target.files);
        const totalImages = images.length + selectedFiles.length;

        if (totalImages > 6) {
            alert('You can only upload up to 6 images.');
            return;
        }

        // Update state with new images
        setImages((prevImages) => [...prevImages, ...selectedFiles]);
    };

    const handleRemoveImage = (index) => {
        setImages((prevImages) => prevImages.filter((_, i) => i !== index));
    };

    // ---------------------------------------------

    const handleDocumentChange = (event) => {
        const selectedFiles = Array.from(event.target.files); // Convert FileList to Array
        const totalDocuments = documents.length + selectedFiles.length;

        if (totalDocuments > 3) {
            alert('You can only upload up to 3 documents.');
            return;
        }

        // Update state with new documents
        setDocuments((prevDocs) => [...prevDocs, ...selectedFiles]);
    };

    const handleRemoveDocument = (index) => {
        setDocuments((prevDocs) => prevDocs.filter((_, i) => i !== index)); // Remove the selected document
    };

    const validate = () => {
        const newErrors = {};
        if (logo == null)
          newErrors.logo = "Logo is required.";
    
        if (bannerMultiple.length < 1)
            newErrors.banner = "Banner is required.";
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    //-------------------------------------------

    const handleSubmit = async () => {

        // const Data = {
        //     documents: documents,
        //     gallery: images,
        //     video_link: multipleVideoLink,
        //     banner: bannerMultiple,
        //     thumbnail: logo
        // }
       if(validate()){
        const formData = new FormData();
        // formData.append("thumbnail", logo);
        // formData.append("gallery", images); // Append multiple files for gallery
        // formData.append("banner", bannerMultiple);
        // formData.append("documents", documents);
        // formData.append("video_link", JSON.stringify(multipleVideoLink))
        // console.log(formData);

        // Append thumbnail
        if (logo) {
            formData.append("thumbnail", logo);
        }

        // Append multiple files for gallery
        if (Array.isArray(images) && images.length > 0) {
            images.forEach((image) => {
                formData.append("gallery", image); // No index
            });
        }

        // Append multiple banners
        if (Array.isArray(bannerMultiple) && bannerMultiple.length > 0) {
            bannerMultiple.forEach((banner) => {
                formData.append("banner", banner); // No index
            });
        }

        // Append multiple documents
        if (Array.isArray(documents) && documents.length > 0) {
            documents.forEach((document) => {
                formData.append("documents", document); // No index
            });
        }

        // Append video links as a JSON string
        if (Array.isArray(multipleVideoLink) && multipleVideoLink.length > 0) {
            formData.append("video_link", JSON.stringify(multipleVideoLink));
        }

        // Debugging FormData

        // for (let pair of formData.entries()) {
        //      console.log(pair[0] + ": ", pair[1]);
        // }
        setBtnLoader(true)
        try {
            const response = await CreateMediaHubApi(eventId, formData);
            // console.log(response.data, "CreateMediaHubApi")
            if (response?.data?.success) {
                toast.success(response.data.message)
                setTabValue("Speaker-List");
                Swal.fire({
                  icon: "success",
                  title: "Event",
                  text: response?.data?.message,
                });
            }

        } catch (error) {
            console.error("Error while submitting the form:", error);
            toast.error(error?.response?.data?.message);
        }finally{
            setBtnLoader(false)
        }
    }
    }

    return (
        <>
          <ToastContainer />
            <div className="container-fluid my-0">
                <div className="col-md-12 row">

                    <div className="mb-3 row">
                        <div className="col-md-6 col-sm-4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', justifyContent: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <label className="col-form-label">Upload Event Logo</label>
                                <div className='creat_eevent-media-hub-uploadImageContainer'>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        name="image"
                                        style={{ display: 'none' }}
                                        id="logoUpload"
                                        onChange={handleLogoChange}
                                    />
                                    {logo ? (
                                        <>
                                         <div className='deleteIcon' onClick={handleDeleteLogo}> ⛌ </div>
                                         <img className='img' src={URL.createObjectURL(logo)} alt="Logo" />
                                        </>
                                    ) : (
                                        <label htmlFor="logoUpload" className="imgPlaceholder" >
                                            <div className='flex flex-col cursor-pointer imgUploadIcon'>
                                                <img width="30" src={uplodIcon} alt="Upload Icon"></img>
                                                <p>Upload Image</p>
                                            </div>
                                        </label>
                                    )}
                                </div>
                                {errors.logo && <small className="text-danger">{errors.logo}</small>}
                            </div>
                            <p className='mt-2'>Image format - jpg png jpeg gif<br />Image Size - maximum size 2 MB<br />Image Ratio - 1:1</p>
                        </div>


                        <div className="col-md-6 col-sm-4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', justifyContent: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <label className="col-form-label">Upload Event Banner</label>
                                <div className='creat_eevent-media-hub-uploadImageContainer'>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        name="banner_image"
                                        multiple
                                        style={{ display: 'none' }}
                                        id="videoUpload"
                                        onChange={handleMultipleBanner}
                                    />
                                    {bannerMultiple?.length > 0 ? (
                                        <>
                                            {bannerMultiple?.map((image, index) => (
                                                <div key={index} className="MediaHub-image-preview">
                                                    <img
                                                        src={URL.createObjectURL(image)}
                                                        alt={`Selected ${index}`}
                                                        width="50px"
                                                        className="m-2"
                                                    />
                                                    <button
                                                        onClick={() => handleMultipleDltBanner(index)}
                                                        className="MediaHub-deleteImageButton">
                                                        ⛌
                                                    </button>
                                                </div>
                                            ))}
                                        </>
                                    ) : <label htmlFor="videoUpload" className="imgPlaceholder">
                                        <div className='flex flex-col cursor-pointer imgUploadIcon'>
                                            <img width="30" src={uplodIcon} alt="Upload Icon"></img>
                                            <p>Banners Image</p>
                                        </div>
                                    </label>}
                                </div>
                                {errors.banner && <small className="text-danger">{errors.banner}</small>}
                            </div>
                            <p className='mt-2'>Image format - jpg png jpeg gif<br />Image Size - maximum size 2 MB<br />Image Ratio - 1:1</p>
                        </div>



                        <div className="row my-3">
                            <div>
                                <h3>Images (maximum 6)</h3>
                            </div>
                            <div className="my-3 d-flex justify-content-center">
                                <div className="creat_eevent-media-hub-uploadImageContainer">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        name="image"
                                        style={{ display: 'none' }}
                                        id="multipleImages"
                                        multiple // Allow multiple file selection
                                        onChange={handleImageChange}
                                    />

                                    <label htmlFor="multipleImages" className="imgPlaceholder">
                                        <div className="flex flex-col cursor-pointer imgUploadIcon">
                                            <img width="30" src={uplodIcon} alt="Upload Icon" />
                                            <p>Select Images</p>
                                        </div>
                                    </label>
                                </div>
                            </div>

                            {/* Display Selected Images */}
                            <div className="MediaHub-selected-images">
                                {images?.map((image, index) => (
                                    <div key={index} className="MediaHub-image-preview">
                                        <img
                                            src={URL.createObjectURL(image)}
                                            alt={`Selected ${index}`}
                                            width="100"
                                            className="m-2"
                                        />
                                        <button
                                            onClick={() => handleRemoveImage(index)}
                                            className="MediaHub-deleteImageButton"
                                        >
                                            ⛌
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>


                        {/* <div className="row my-3">
                            <div>
                                <h3>Documents (maximum 3)</h3>
                            </div>
                            <div className="my-3 d-flex justify-content-center">

                                <div className='creat_eevent-media-hub-uploadImageContainer'>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        name="image"
                                        style={{ display: 'none' }}
                                        id="DocumentUpload"
                                    />


                                    <label htmlFor="DocumentUpload" className="imgPlaceholder" >
                                        <div className='flex flex-col cursor-pointer imgUploadIcon'>
                                            <img width="30" src={uplodIcon} alt="Upload Icon"></img>
                                            <p>Select Document</p>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div> */}

                        <div className="row my-3">
                            <div>
                                <h3>Documents (maximum 3)</h3>
                            </div>
                            <div className="my-3 d-flex justify-content-center">
                                <div className="creat_eevent-media-hub-uploadImageContainer">
                                    <input
                                        type="file"
                                        accept=".pdf,.doc,.docx,.txt,.xlsx,.xls"
                                        name="document"
                                        style={{ display: 'none' }}
                                        id="DocumentUpload"
                                        multiple // Allow multiple file selection
                                        onChange={handleDocumentChange}
                                    />

                                    <label htmlFor="DocumentUpload" className="imgPlaceholder">
                                        <div className="flex flex-col cursor-pointer imgUploadIcon">
                                            <img width="30" src={uplodIcon} alt="Upload Icon" />
                                            <p>Select Documents</p>
                                        </div>
                                    </label>
                                </div>
                            </div>

                            {/* Display Uploaded Documents */}
                            <div className="uploaded-documents">
                                {documents.map((document, index) => (
                                    <div key={index} className="document-preview">
                                        <img src={DocImg} />
                                        <p className="text-center">{document.name}</p>
                                        <button
                                            onClick={() => handleRemoveDocument(index)}
                                            className="deleteDocumentButton"
                                        >
                                            ⛌
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="mt-3">
                                <h3 className="form-heading">Videos Url</h3>
                                <div className="row">
                                    <div className="col-md-8">
                                        {/* <label className="form-label ">Video URL</label> */}
                                        <div>
                                            <div className="d-flex form-group ">
                                                <div className="col-8">
                                                    <input
                                                        type="url"
                                                        value={video_link}
                                                        onChange={(e) => setVideo_link(e.target.value)}
                                                        className="form-control"
                                                        placeholder="Enter Video URL"
                                                    />
                                                </div>
                                                <div className="create-event-save-btn">
                                                    <button className="ms-4" onClick={handleAddMultipleURL}>Add Link</button>
                                                </div>
                                            </div>
                                            <div className="col-md-10">
                                                {multipleVideoLink?.map((item, idxx) => {
                                                    return (
                                                        <div className="create-msg-date-time-bar d-flex align-items-center gap-4 my-3">
                                                            <span className="create-Message">{item}</span>
                                                            <div className="create-event-save-btn">
                                                                <button className="p-1" onClick={() => handleDeleteURL(idxx)}>Remove</button>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-end gap-4 mt-5 px-5">
                            <div className="">
                            <div className="">
                                    <button className="btn btn-outline-primary" type="button"
                                     onClick={()=>setTabValue("Speaker-List")}
                                    >Skip</button>
                                </div>
                            </div>

                            <div className="">
                                <button className="btn btn-primary" onClick={handleSubmit}>{btnLoader && <BtnLoader/>}Save and continue</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default MediaHub;